import api from "./api";
import {
  DynamicQueryResponse,
  DynamicRequestSchema,
} from "../types/dynamicQueryTypes";

const dynamic_base = "/dynamic_query";

export const dynamicQueryService = {
  list: async (params: DynamicRequestSchema): Promise<DynamicQueryResponse> => {
    const response = await api.post(`${dynamic_base}/`, params);
    return response.data;
  },
};
